import { availablePeriods, Period } from 'enums/shared/period';
import useQueryParam from 'hooks/shared/useQueryParam';

const usePeriodQueryParam = (): [Period, (period: Period) => void] => {
  const [period, setPeriod] = useQueryParam<Period>('period', {
    ifAbsent: Period.Year,
    provider: (val) => {
      if (availablePeriods.map((item) => item.toString()).includes(val)) {
        return val as Period;
      } else {
        return Period.Year;
      }
    },
  });

  return [period, setPeriod];
};

export default usePeriodQueryParam;
